
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/food-areas",
      function () {
        return require("private-next-pages/services/food-areas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/food-areas"])
      });
    }
  